module.exports = __webpack_public_path__ + "img/CompScope_Bright_05.6ff6bbed.png";